import {Component, ViewChild, OnInit} from '@angular/core';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { BehaviorSubject, distinctUntilChanged, map } from 'rxjs';
import { AppMessageService } from '~app/shared/app-message/app-message.service';

@Component({
  selector: 'qm-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss']
})
export class ToastContainerComponent implements OnInit {

  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer: ToastContainerDirective;

  showCloseAll = new BehaviorSubject(false);

  constructor(
    private toastrService: ToastrService,
    private appMessageService: AppMessageService,
  ) {
  }

  ngOnInit(): void {
    this.toastrService.overlayContainer = this.toastContainer;

    this.appMessageService.currentlyActive$.pipe(
      map(count => count > 0),
      distinctUntilChanged(),
    ).subscribe(
      this.showCloseAll
    );
  }

  onCloseAllClick(): void {
    this.appMessageService.closeAll();
  }
}
